<div class="snackbar-container">
  <div class="snackbars">
    @for (snackBar of snackBars$ | async; track snackBar) {
      @if ((snackBar.closed | async) === false) {
        <app-snack-bar @fadeIn [snackbarRef]="snackBar"
        ></app-snack-bar>
      }
    }
  </div>
</div>
